import { Box } from "@material-ui/core"
import NCText from "../../shared/NCText"
import { useGetDriverTrainings } from "../../services/queries"
import { useTranslation } from "react-i18next"
import { formatDate } from "../../libs/utils"
import NCTable from "../../shared/table/NCTable"
import { useState } from "react"

const DriverTrainingList = ({ driverId }) => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(5)

  const { data } = useGetDriverTrainings(driverId)
  const results = data?.data?.data || []

  const columns = [
    {
      Header: t("training.name"),
      accessor: cell => cell?.training_name,
      disableSortBy: true
    },
    {
      Header: t("training.topic"),
      accessor: cell => cell?.training_topic,
      disableSortBy: true
    },
    {
      Header: t("training.status"),
      accessor: cell =>
        cell?.completed ? (
          <Box style={{ color: "#10B981", fontWeight: 600 }}>
            {t("training.completed")}
          </Box>
        ) : (
          <Box style={{ color: "#6B7280" }}>
            {t("training.not_completed")}
          </Box>
        ),
      disableSortBy: true
    },
    {
      Header: t("training.completed_date"),
      accessor: cell =>
        cell?.completed_date ? formatDate(cell?.completed_date) : "-",
      disableSortBy: true
    }
  ]

  if (!results.length) {
    return (
      <NCText style={{ fontSize: "13px", color: "#9CA3AF" }}>
        {t("training.no_trainings")}
      </NCText>
    )
  }

  const paginated = results.slice((page - 1) * pageSize, page * pageSize)
  const total_pages = Math.ceil(results.length / pageSize)

  return (
    <NCTable
      columns={columns}
      page={page}
      onNext={() => setPage(prev => (page < total_pages ? prev + 1 : prev))}
      onPrev={() => setPage(prev => (prev > 1 ? prev - 1 : prev))}
      pageCount={total_pages}
      gotoPage={setPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      data={paginated}
      overrideFooterCss={{
        position: "static",
        margin: 0
      }}
    />
  )
}

export default DriverTrainingList
